import { Share2 } from "lucide-react";
import { useSharedProjects } from "@/hooks/useProjects";
import { useNavigation } from "@/contexts/NavigationContext";

export const SidebarSectionShared = () => {
  const { navigateToProject } = useNavigation();
  const { data: sharedProjects } = useSharedProjects();

  if (!sharedProjects || sharedProjects.length === 0) return null;

  return (
    <div>
      <h3 className="text-xs font-medium text-tertiary uppercase mb-2 px-3 flex items-center gap-1.5">
        <Share2 className="w-3 h-3" />
        Compartilhado comigo
      </h3>
      <div className="space-y-0.5">
        {sharedProjects.map((project) => (
          <button
            key={project.id}
            onClick={() => navigateToProject(project.id)}
            className="w-full flex items-center gap-2 px-3 py-1.5 text-xs text-secondary hover:bg-hover rounded-md transition-colors"
          >
            <span className="flex-shrink-0">{project.icon}</span>
            <span className="truncate">{project.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
